import defaultRules from './DefaultRules'

let customRules = []
let detailedValidation = []
const validator = () => {
  let ValidatorObj = {
    addRules: undefined,
    validate: undefined,
    changeRule: undefined,
    changeMessage: undefined
  }
  ValidatorObj.addRules = (rules) => {
    customRules = rules
  }
  ValidatorObj.changeRule = (name, method) => {
    if (defaultRules.includes(allRules().filter(r => r.name === name)[0])) { defaultRules[defaultRules.indexOf(allRules().filter(r => r.name === name)[0])].rule = method }
    // if (defaultRules.includes(allRules().filter(r => r.name === name)[0])) { throw new Error('Default rules cannot be changed.') }
    if (customRules.includes(allRules().filter(r => r.name === name)[0])) { customRules[customRules.indexOf(allRules().filter(r => r.name === name)[0])].rule = method }
  }
  ValidatorObj.changeMessage = (name, message) => {
    if (defaultRules.includes(allRules().filter(r => r.name === name)[0])) { defaultRules[defaultRules.indexOf(allRules().filter(r => r.name === name)[0])].message = message }
    if (customRules.includes(allRules().filter(r => r.name === name)[0])) { customRules[customRules.indexOf(allRules().filter(r => r.name === name)[0])].message = message }
  }
  ValidatorObj.validate = (value, rules = [], type = false) => {
    // validates value
    if (rules.length > 0) {
      return type === false ? simpleValidate(value, rules) : getDetailedValidations(value, rules)
    } else {
      throw new Error('rules array cannot be empty')
    }
  }
  return ValidatorObj
}

const allRules = () => [...defaultRules, ...customRules]
const getMethodsForName = (name) => allRules().filter(r => r.name === name)[0]
const simpleValidate = (value, rules) => rules.map(r => getMethodsForName(r).rule(value)).every(v => v)

const detailedValidate = (value, rules) => rules.map((r, index) => {
  detailedValidation.push({
    test: getMethodsForName(r).name,
    isValid: getMethodsForName(r).rule(value),
    message: getMethodsForName(r).message
  })
})
const getDetailedValidations = (value, rules) => {
  detailedValidate(value, rules)
  let detailedValidationCopy = [...detailedValidation]
  detailedValidation = []
  return detailedValidationCopy
}
export default validator
